import {memo} from 'react';
import {DaycareCenterData} from '@/map/@types';
import {AROUND_DATA_OPTIONS} from '@/map/constants';
import {AreaAnalyticsFilter} from '@/map/enums';
import {NearbyInfoMarker} from './Marker';

interface IProps extends naver.maps.MarkerOptions {
  item: DaycareCenterData;
}

export const DaycareCenterMarker = memo(
  ({map, position, item}: IProps) => {
    return (
      <NearbyInfoMarker
        typeInfo={AROUND_DATA_OPTIONS[AreaAnalyticsFilter.DAYCARE_CENTER]}
        config={{
          map,
          position,
        }}
        item={{
          name: item.name,
          count: item.childrenCount,
        }}
      />
    );
  },
  (prevProps: IProps, nextProps: IProps) => {
    return prevProps.position.toString() === nextProps.position.toString();
  }
);
